import { postQueryAction } from "../shared/queryActionsModel";
const reasonFields = reason => typeof reason === 'object' && reason !== null ? { reason_code: reason.reason_code, note: reason.note || null } : { reason };

export function cancelTask(queryPk, userId, reason) {
  return postQueryAction(queryPk, "cancel", reasonFields(reason));
}

export function moveStatusBack(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "move-status", { to_status: toStatus, ...reasonFields(reason) });
}

export function moveStatusForward(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "move-status-forward", { to_status: toStatus, reason });
}

export function reassignTask(queryPk, toUserId, reason, userId) {
  return postQueryAction(queryPk, "reassign", { to_user_id: toUserId, reason });
}

export function unparkTask(queryPk, userId, toStatus, reason) {
  return postQueryAction(queryPk, "unpark", { to_status: toStatus, ...reasonFields(reason) });
}

export function notifyUnavailableParts(queryPk, { userId, messageText, partIds }, options) {
  const body = { message_text: messageText, part_ids: partIds };
  return postQueryAction(queryPk, "notify-unavailable-parts", body, { ...options, actor: userId });
}

export function requestBillingDetails(queryPk, userId, messageText, options) {
  const body = { message_text: messageText };
  return postQueryAction(queryPk, "request-billing-details", body, { ...options, actor: userId });
}
